export const PRIORITY_COLORS = {
    Critical: { bg: 'bg-[#ffdad6] dark:bg-red-950/80 dark:border dark:border-red-800/50', text: 'text-[#93000a] dark:text-red-300' },
    High: { bg: 'bg-red-50 dark:bg-red-950/60 dark:border dark:border-red-800/40', text: 'text-red-600 dark:text-red-400' },
    Medium: { bg: 'bg-[#c9e6ff] dark:bg-blue-950/80 dark:border dark:border-blue-800/50', text: 'text-[#004c6e] dark:text-blue-300' },
    Low: { bg: 'bg-[#e7e8e9] dark:bg-slate-800 dark:border dark:border-slate-700', text: 'text-[#424750] dark:text-slate-300' },
    None: { bg: 'bg-slate-100 dark:bg-slate-800', text: 'text-slate-400 dark:text-slate-400' },
};

export const PRIORITY_OPTIONS = ['Critical', 'High', 'Medium', 'Low', 'None'];

export const STATUS_COLORS = {
    Draft: 'bg-purple-50 text-purple-700 dark:bg-purple-950/70 dark:text-purple-300 border border-dashed border-purple-300 dark:border-purple-700',
    Backlog: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300 dark:border dark:border-slate-700',
    'In Progress': 'bg-blue-50 text-blue-600 dark:bg-blue-950/70 dark:text-blue-300 dark:border dark:border-blue-800/50',
    'Under Review': 'bg-amber-50 text-amber-600 dark:bg-amber-950/70 dark:text-amber-300 dark:border dark:border-amber-800/50',
    Completed: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-950/70 dark:text-emerald-300 dark:border dark:border-emerald-800/50',
    Closed: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-950/70 dark:text-emerald-300 dark:border dark:border-emerald-800/50',
    Close: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-950/70 dark:text-emerald-300 dark:border dark:border-emerald-800/50',
    'On Hold': 'bg-orange-50 text-orange-600 dark:bg-orange-950/70 dark:text-orange-300 dark:border dark:border-orange-800/50',
    Cancelled: 'bg-red-50 text-red-400 dark:bg-red-950/50 dark:text-red-400 dark:border dark:border-red-800/40',
};

export const STATUS_OPTIONS = ['Backlog', 'In Progress', 'Under Review', 'Completed', 'On Hold', 'Cancelled'];

export const SOURCE_BADGE = {
    progress_update: { label: 'Progress Update', color: 'bg-blue-50 text-blue-600 dark:bg-blue-950/70 dark:text-blue-300' },
    completion: { label: 'Completed', color: 'bg-emerald-50 text-emerald-600 dark:bg-emerald-950/70 dark:text-emerald-300' },
    status_change: { label: 'Status Change', color: 'bg-amber-50 text-amber-600 dark:bg-amber-950/70 dark:text-amber-300' },
    attachment_upload: { label: 'Attachment', color: 'bg-indigo-50 text-indigo-600 dark:bg-indigo-950/70 dark:text-indigo-300' },
    manual: { label: null, color: '' },
};

